import { Component, Signal, ViewEncapsulation } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { DsColors } from '@levelaccess/design-system';
import { UserOptinFeatures } from '../../../../constants/user-optin';
import { A11yService } from '../../../../services/a11y.service';
import { UserOptinService } from '../../../../services/user-optin.service';
import { TranslateService } from '../../../../translate/translate.service';

@Component({
  selector: 'app-new-nav-toggle',
  templateUrl: './new-nav-toggle.component.html',
  styleUrls: ['./new-nav-toggle.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class NewNavToggleComponent {
  public readonly labelColor: DsColors = DsColors.White;
  protected navSwitchState: Signal<boolean>;

  constructor(
    private a11yService: A11yService,
    private translateService: TranslateService,
    private userOptinService: UserOptinService,
  ) {
    this.navSwitchState = toSignal(this.userOptinService.hasOptedIn$(UserOptinFeatures.verticalNavigation), {
      initialValue: false,
    });
  }

  public onValueChange(value: boolean): void {
    this.a11yService.setMessage(this.translateService.instant('navigation_switched_announcement'));
    this.userOptinService.updateOptin(UserOptinFeatures.verticalNavigation, value);
  }
}
